// import { Kilogram } from "./base-units";
import { Unit, UnitPrefix, BaseUnits } from "uom";
/** The derived unit for mass quantities ( <code>g</code> ).
 * The base unit for mass quantity is {@link #Kilogram}.
 */
export var Gram = Unit.divideNumber("Gram", 1000.0, BaseUnits.Kilogram);
/// Mass
export var PoundLb = Unit.divideNumber("PoundLb", 100000000.0 / 45359237.0, BaseUnits.Kilogram);
// http://www.wolframalpha.com/input/?i=kg
export var Grain = Unit.divideNumber("Grain", 100000000000.0 / 6479891.0, BaseUnits.Kilogram);
// http://www.wolframalpha.com/input/?i=grain
export var Slug = Unit.timesNumber("Slug", 14.5939, BaseUnits.Kilogram);
export var Tonne = Unit.timesNumber("Tonne", 1000.0, BaseUnits.Kilogram);
export var MilliGram = UnitPrefix.Milli("MilliGram", Gram);
//# sourceMappingURL=mass.js.map